import type { ReactNode } from 'react';

/**
 * Layer A (per-client) "game not deployed for this client" screen.
 *
 * Shared across all six game frontends (pickem, squares, daily-reveal, lobby, survivor, bingo)
 * via `ClientGameGate` below, which wraps each app's root and renders this when the game is
 * disabled for the client.
 */
export function GameUnavailable() {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#121212',
        color: '#fff',
        fontFamily: 'Inter, sans-serif',
      }}
    >
      This game is not available.
    </div>
  );
}

export interface ClientGameGateProps {
  /**
   * Whether the client deployed this game (Layer A) — pass
   * `isClientGameEnabled('<game>')` from `@low6-pickem/frontend-shared`. Taken as a prop so
   * this package (vendored into apps that don't ship frontend-shared, e.g. admin) stays free
   * of a frontend-shared dependency.
   */
  enabled: boolean;
  children: ReactNode;
}

/**
 * Renders `children` only if the client enabled the game (Layer A); otherwise renders the
 * `GameUnavailable` fallback screen. Use this to wrap an app's root providers/routes so the
 * app never registers routes or mounts providers for a game the client didn't deploy.
 */
export function ClientGameGate({ enabled, children }: ClientGameGateProps) {
  if (!enabled) {
    return <GameUnavailable />;
  }

  return <>{children}</>;
}
